import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { ProductsState, PRODUCTS_SLICE_NAME } from './models';

export const productsSelector = (state: RootState): ProductsState => state[PRODUCTS_SLICE_NAME];

export const selectQuery = createSelector(productsSelector, (state: ProductsState) => state.query);
